import Vue from "vue";
var bus = new Vue();
export default bus;



//////////////////
// WEBPACK FOOTER
// ./src/likesBus.ts
// module id = 60
// module chunks = 0